// src/contexts/geral/CidadeCepContext.js
import React, { createContext, useContext, useCallback } from 'react';
import { listarCeps, adicionarCep, excluirCep, consultarCep } from '../../services/geral/CidadeCepService';
import { useMessage } from './MessageContext';

const CidadeCepContext = createContext(null);
export const useCidadeCep = () => useContext(CidadeCepContext);

export const CidadeCepProvider = ({ children }) => {
  const { showMessage } = useMessage();
  const executar = useCallback(async (acao) => {
    try { return await acao(); }
    catch (error) {
      showMessage(error?.message || 'Não foi possível concluir a operação de CEP.', 'warning');
      throw error;
    }
  }, [showMessage]);
  return <CidadeCepContext.Provider value={{
    listar: useCallback((cidadeId) => executar(() => listarCeps(cidadeId)), [executar]),
    adicionar: useCallback((registro) => executar(() => adicionarCep(registro)), [executar]),
    excluir: useCallback((id) => executar(() => excluirCep(id)), [executar]),
    consultar: useCallback((cep) => executar(() => consultarCep(cep)), [executar]),
  }}>{children}</CidadeCepContext.Provider>;
};
